import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import {
  getAll,
  createItem,
  updateItem,
  deleteById,
  getId,
  getSynchNrax,
  getSynchNrablank,
  getSynchNracustblank,
  getSynchNracustx,
  getSynchMaterial,
  getSynchCrprgp,
  getSynchBatch,
  getSynchCustomer,
  getSynchMaterialExt,
  getSynchFPRE,
} from "./generalSettingAPI";

const initialState = {
  data: [],
  dataId: [],
  loading: false,
  error: null,
  pageNo: 1,
  pageSize: 10,
  totalRecord: 0,
  selected: null,
  result: null,
};

export const fetchAll = createAsyncThunk(
  "generalSetting/fetchAll",
  async (payload) => {
    const response = await getAll(payload);
    return response.data;
  }
);

export const fetchId = createAsyncThunk(
  "generalSetting/fetchId",
  async (payload) => {
    const response = await getId(payload);
    return response.data;
  }
);

export const fetchSettingId = createAsyncThunk(
  "generalSetting/fetchSettingId",
  async (payload) => {
    const response = await getId(payload);
    return response.data;
  }
);

export const addItem = createAsyncThunk(
  "generalSetting/addItem",
  async (payload) => {
    const response = await createItem(payload);
    return response.data;
  }
);

export const editItem = createAsyncThunk(
  "generalSetting/editItem",
  async ({ params, id }) => {
    const response = await updateItem(params, id);
    return response.data;
  }
);

export const removeById = createAsyncThunk(
  "generalSetting/removeById",
  async (id) => {
    const response = await deleteById(id);
    return response.data;
  }
);

export const postSynchNrax = createAsyncThunk(
  "generalSetting/postSynchNrax",
  async ({ i_Principal, i_Customer, i_Material, i_PH3 }) => {
    const response = await getSynchNrax(
      i_Principal,
      i_Customer,
      i_Material,
      i_PH3
    );
    return response;
  }
);
export const postSynchNrablank = createAsyncThunk(
  "generalSetting/postSynchNrablank",
  async ({ i_Principal, i_Customer, i_Material, i_PH3 }) => {
    const response = await getSynchNrablank(
      i_Principal,
      i_Customer,
      i_Material,
      i_PH3
    );
    return response;
  }
);

export const postSynchCustomer = createAsyncThunk(
  "generalSetting/postSynchNrablank",
  async ({ P_CustomerCode, P_CustomerName }) => {
    const response = await getSynchCustomer(P_CustomerCode, P_CustomerName);
    return response;
  }
);

export const postSynchNracustx = createAsyncThunk(
  "generalSetting/postSynchNracustx",
  async ({ i_Principal, i_Customer, i_CustGroup2 }) => {
    const response = await getSynchNracustx(
      i_Principal,
      i_Customer,
      i_CustGroup2
    );
    return response;
  }
);

export const postSynchNracustblank = createAsyncThunk(
  "generalSetting/postSynchNracustblank",
  async ({ i_Principal, i_Customer, i_CustGroup2 }) => {
    const response = await getSynchNracustblank(
      i_Principal,
      i_Customer,
      i_CustGroup2
    );
    return response;
  }
);

export const postSynchMaterial = createAsyncThunk(
  "generalSetting/postSynchMaterial",
  async ({ P_material, P_DistChannel }) => {
    const response = await getSynchMaterial(P_material, P_DistChannel);
    return response;
  }
);

export const postSynchMaterialExt = createAsyncThunk(
  "generalSetting/postSynchMaterial",
  async ({
    tableName,
    P_SalesOrg,
    P_Material,
    P_Customer,
    P_Batch,
    P_Plant,
    P_IC4,
    P_DocCat,
    P_CG1,
  }) => {
    const response = await getSynchMaterialExt(
      tableName,
      P_SalesOrg,
      P_Material,
      P_Customer,
      P_Batch,
      P_Plant,
      P_IC4,
      P_DocCat,
      P_CG1
    );
    return response;
  }
);

export const postSynchCrprgp = createAsyncThunk(
  "generalSetting/postSynchCrprgp",
  async (payload) => {
    const response = await getSynchCrprgp(payload);
    return response;
  }
);

export const postSynchBatch = createAsyncThunk(
  "generalSetting/postSynchBatch",
  async ({ P_MATERIAL, P_BATCH }) => {
    const response = await getSynchBatch(P_MATERIAL, P_BATCH);
    return response;
  }
);

export const postSynchFPRE = createAsyncThunk(
  "generalSetting/postSynchFPRE",
  async (payload) => {
    const response = await getSynchFPRE(payload);
    return response;
  }
);

export const generalSettingSlice = createSlice({
  name: "generalSetting",
  initialState,
  reducers: {
    resetData: () => initialState,
    setSelected: (state, action) => {
      state.selected = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchAll.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchAll.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload.data;
        state.pageNo = action.payload.pageNo;
        state.pageSize = action.payload.pageSize;
        state.totalRecord = action.payload.totalRecord;
      })
      .addCase(fetchId.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchId.fulfilled, (state, action) => {
        state.loading = false;
        state.dataId = action.payload.data;
        state.pageNo = action.payload.pageNo;
        state.pageSize = action.payload.pageSize;
        state.totalRecord = action.payload.totalRecord;
      })
      .addCase(fetchSettingId.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchSettingId.fulfilled, (state, action) => {
        state.loading = false;
        state.dataId = action.payload.data;
        state.pageNo = action.payload.pageNo;
        state.pageSize = action.payload.pageSize;
        state.totalRecord = action.payload.totalRecord;
      })
      .addCase(addItem.pending, (state) => {
        state.loading = true;
      })
      .addCase(addItem.fulfilled, (state, action) => {
        state.loading = false;
        state.result = action.payload;
      })
      .addCase(editItem.pending, (state) => {
        state.loading = true;
      })
      .addCase(editItem.fulfilled, (state, action) => {
        state.loading = false;
        state.result = action.payload;
      })
      .addCase(removeById.pending, (state) => {
        state.loading = true;
      })
      .addCase(removeById.fulfilled, (state, action) => {
        state.loading = false;
        state.result = action.payload;
      })
      .addCase(postSynchNrax.pending, (state) => {
        state.loading = true;
      })
      .addCase(postSynchNrax.fulfilled, (state, action) => {
        state.loading = false;
        state.result = action.payload;
      })
      .addCase(postSynchNrablank.pending, (state) => {
        state.loading = true;
      })
      .addCase(postSynchNrablank.fulfilled, (state, action) => {
        state.loading = false;
        state.result = action.payload;
      })
      .addCase(postSynchNracustx.pending, (state) => {
        state.loading = true;
      })
      .addCase(postSynchNracustx.fulfilled, (state, action) => {
        state.loading = false;
        state.result = action.payload;
      })
      .addCase(postSynchNracustblank.pending, (state) => {
        state.loading = true;
      })
      .addCase(postSynchNracustblank.fulfilled, (state, action) => {
        state.loading = false;
        state.result = action.payload;
      })
      .addCase(postSynchMaterial.pending, (state) => {
        state.loading = true;
      })
      .addCase(postSynchMaterial.fulfilled, (state, action) => {
        state.loading = false;
        state.result = action.payload;
      })
      .addCase(postSynchCrprgp.pending, (state) => {
        state.loading = true;
      })
      .addCase(postSynchCrprgp.fulfilled, (state, action) => {
        state.loading = false;
        state.result = action.payload;
      })
      .addCase(postSynchBatch.pending, (state) => {
        state.loading = true;
      })
      .addCase(postSynchBatch.fulfilled, (state, action) => {
        state.loading = false;
        state.result = action.payload;
      })
      .addCase(postSynchFPRE.pending, (state) => {
        state.loading = true;
      })
      .addCase(postSynchFPRE.fulfilled, (state, action) => {
        state.loading = false;
        state.result = action.payload;
      });
  },
});

export const { resetData, setSelected } = generalSettingSlice.actions;

export const selectData = (state) => state.generalSetting.data;
export const selectDataId = (state) => state.generalSetting.dataId;
export const selectSettingId = (state) => state.generalSetting.dataId;
export const selectLoading = (state) => state.generalSetting.loading;
export const selectError = (state) => state.generalSetting.error;
export const selectPageNo = (state) => state.generalSetting.pageNo;
export const selectPageSize = (state) => state.generalSetting.pageSize;
export const selectTotalRecord = (state) => state.generalSetting.totalRecord;
export const selectSelected = (state) => state.generalSetting.selected;
export const selectResult = (state) => state.generalSetting.result;

export default generalSettingSlice.reducer;
